module.exports = __webpack_public_path__ + "img/PoliticsWarning.554259a2.svg";